import LABEL from '../../../business-const/Label/Label'

import { 
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    ButtonPadraoSubmit,
} from '../../../business-components/Button/Button'



export const AlterarFamiliarInventarioRecursosFinanceiros = ({ values, handleChange }) => {

    return (
        <TextFieldNumberSelect
            name={'alterarFamiliarInventarioRecursosFinanceiros'}
            label={LABEL.familiarInventario}
            value={values.alterarFamiliarInventarioRecursosFinanceiros || ''}
            onChange={handleChange}
            list={values.totalRecursosFinanceiros}
        />
    )
}

export const ButtonAlterarFamiliarInventarioRecursosFinanceiros = ({ values, setFieldValue }) => {

    return (

        <ButtonPadraoSubmit
            className="mt-2 ml-2"
            label={LABEL.buttonAlterarTodos}
            onClick={() => {
                values.recursosFinanceiros?.forEach( (linha, ind) => {

                    linha.familiar = values.alterarFamiliarInventarioRecursosFinanceiros
                })

                setFieldValue('alterarFamiliarInventarioRecursosFinanceiros', '')
            }}
            disabled={!values.alterarFamiliarInventarioRecursosFinanceiros}
        />
    )
}
